import { BaseClient } from '../BaseClient';
import {
  DispatchServiceItemRequest,
  DispatchServiceItemResponse,
  MeasureQuickDiagnostic,
  MeasureQuickDispatchFilter,
  MeasureQuickDispatchList,
  MeasureQuickDispatchState,
  MeasureQuickReading,
  MeasureQuickReadingFilter,
  MeasureQuickReadingList,
} from '../compiled-protos/measurequick';
import { MeasureQuickServiceClient } from '../compiled-protos/measurequick.client';

class MeasureQuickClient extends BaseClient {
  self: MeasureQuickServiceClient;

  constructor(host: string, userID?: number) {
    super(host, userID);
    this.self = new MeasureQuickServiceClient(this.transport);
  }

  /**
   * Dispatches one specific system (service item) of a job to the assigned technician's
   * MeasureQuick list. Skips (non-HVAC, unassigned, unmapped tech) come back as
   * success=false with a human-readable message rather than an error.
   */
  public async DispatchServiceItem(req: DispatchServiceItemRequest) {
    return await this.self.dispatchServiceItem(req, this.getMetaData()).response;
  }

  /**
   * Readings parsed out of MeasureQuick Pro Report PDFs, newest session first. One result per
   * test session, so an HVAC Tune-up returns a Test In and a Test Out for the same visit.
   * Filter by service item, event, or both; 0 means "any".
   */
  public async BatchGetMeasureQuickReadings(req: MeasureQuickReadingFilter) {
    return await this.self.batchGetMeasureQuickReadings(req, this.getMetaData()).response;
  }

  /**
   * Dispatch state for a service item and/or event, newest first. Readings alone cannot tell
   * "dispatched, waiting on the technician" apart from "never dispatched" — both are zero readings
   * — so this is what a waiting indicator has to key on. Canceled dispatches are excluded server
   * side.
   */
  public async BatchGetMeasureQuickDispatches(req: MeasureQuickDispatchFilter) {
    return await this.self.batchGetMeasureQuickDispatches(req, this.getMetaData()).response;
  }
}

export {
  DispatchServiceItemRequest,
  DispatchServiceItemResponse,
  MeasureQuickClient,
  MeasureQuickDiagnostic,
  MeasureQuickDispatchFilter,
  MeasureQuickDispatchList,
  MeasureQuickDispatchState,
  MeasureQuickReading,
  MeasureQuickReadingFilter,
  MeasureQuickReadingList,
};
